import { useEffect } from 'react'
import { Capacitor, PluginListenerHandle } from '@capacitor/core'
import { AppState, App as CapacitorApp } from '@capacitor/app'

// to match the way CapacitorApp works as a singleton...
let handleAppStateChangePromise: Promise<PluginListenerHandle>|null = null

const triggerResize = () => window.dispatchEvent(new Event('resize'))
const handleAppStateChange = (state: AppState) => {
	if(state.isActive) {
		setTimeout(triggerResize, 150)
	}
}
const handleOrientationChange = () => setTimeout(triggerResize, 150)
const handleViewportResize = () => requestAnimationFrame(triggerResize)

// manually correct a framework bug where the app is brought into the
// foreground but only half of the screen is used
// credits to thad for the actual techniques, please refer questions to him
// this hook may not be required in later versions of capacitor, safari
// or ios where the issue is potentially cleaned up in the future
export const useForegroundedHalfScreenBugFix = () => {
	useEffect(() => {
		if(!Capacitor.isNativePlatform()) {
			return
		}
		// since this is async let's not mess with potential race issues
		// related to useEffect and potential add/remove of the component,
		// we can just set it up once for the app and not clean it up
		if(!handleAppStateChangePromise) {
			handleAppStateChangePromise = CapacitorApp.addListener('appStateChange', handleAppStateChange)
		}
		// we have clean synchronous handlers here though so why not
		window.addEventListener('orientationchange', handleOrientationChange)
		if(window.visualViewport) {
			window.visualViewport.addEventListener('resize', handleViewportResize)
		}
		return () => {
			window.removeEventListener('orientationchange', handleOrientationChange)
			if(window.visualViewport) {
				window.visualViewport.removeEventListener('resize', handleViewportResize)
			}
		}
	}, [])
}
